import {defineNuxtPlugin} from '#imports';
import {focusInput} from '~/directives/focusInput';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('focusInput', focusInput);
});
